module.exports = __webpack_public_path__ + "static/Sonyax43-0a63d87a89081a3d827829b54be1b63d.png";